import styled from 'styled-components';
import { ReactComponent as LeftArrowIcon } from 'src/assets/icons/bonus-game/left-arrow.svg';
import { useNavigate } from 'react-router-dom';
import { ReactNode } from 'react';

const HeaderWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`;

const HeaderContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0px 20px;
  justify-content: space-between;
`;

const Title = styled.h1`
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
`;

const RightContent = styled.div``;

interface MobileHeaderProps {
  title: string;
  headerRight?: ReactNode;
  headerLeft?: ReactNode;
}

export const MobileHeader = ({
  title,
  headerRight,
  headerLeft,
}: MobileHeaderProps) => {
  const navigate = useNavigate();
  function handleGoBack() {
    console.log('wef');

    navigate(-1);
  }

  return (
    <HeaderWrapper>
      <HeaderContent>
        {headerLeft ? (
          headerLeft
        ) : (
          <LeftArrowIcon
            style={{ zIndex: 100 }}
            onClick={handleGoBack}
            color="rgba(82, 90, 103, 1)"
            width={24}
            height={24}
          />
        )}
        <Title>{title}</Title>
        <RightContent>{headerRight}</RightContent>
      </HeaderContent>
    </HeaderWrapper>
  );
};
